import { gateway } from "../../../gateway";
import { FlowTask } from "../interfaces/flowTask.interface";

/**
 * Action to fetch todo tasks for a specific kanban category
 *
 * Backend endpoint: GET /todo-tasks/self?kanbanCategoriesUid={categoryUid}
 * Response format: { status: 200, message: "Todo tasks", data: FlowTask[] }
 */
export const getTodoTasksAction = async (): Promise<FlowTask[]> => {
  try {
    const response = await gateway.get("/todo-tasks/self");

    const tasks = response.data?.data ?? response.data;
    // if (Array.isArray(tasks) && tasks.length > 0) {
    //   console.log('Sample task structure:', tasks[0]);
    // }
    return Array.isArray(tasks) ? tasks : [];
  } catch (error: any) {
    console.error("Error fetching todo tasks:", error);
    const errorMessage =
      error?.response?.data?.message || error?.message || "Failed to fetch todo tasks";
    throw new Error(errorMessage);
  }
};
